export default __webpack_public_path__ + "static/media/Balloon_00.9a060591.png";